import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Input} from '@components/common/base/input'
import {useProjectParticipantStore} from './project-participants-store'
import {Sort} from './types'

export const UsersTabTableHeader = observer(() => {
  const [state, store] = useProjectParticipantStore()

  const bem = Util.bemFrom('project-participants')

  const clickSort = (sortType: Sort) => () => {
    if (sortType === state.sort) {
      store.toggleSortAsc()
    } else {
      store.setSort(sortType)
      store.setSortAsc(true)
    }
  }

  return (
    <>
      <Input
        onChange={store.setFilter}
        placeholder={Lang.msg.proj.searchPl}
        value={state.filter}
        className="mb-8"
      />

      <div className={bem('head')}>
        <div
          className={bem('head-cell', {
            tick: true,
            asc: state.sortAsc,
            sorted: state.sort === 'tick'
          })}
          onClick={clickSort('tick')}
        />
        <div
          className={bem('head-cell', {
            name: true,
            asc: state.sortAsc,
            sorted: state.sort === 'name'
          })}
          onClick={clickSort('name')}
        >
          {Lang.msg.proj.colName}
        </div>
        <div
          className={bem('head-cell', {
            position: true,
            asc: state.sortAsc,
            sorted: state.sort === 'position'
          })}
          onClick={clickSort('position')}
        >
          {Lang.msg.proj.colPosition}
        </div>
        <div
          className={bem('head-cell', {
            deps: true,
            asc: state.sortAsc,
            sorted: state.sort === 'deps'
          })}
          onClick={clickSort('deps')}
        >
          {Lang.msg.proj.colDep}
        </div>
        <div
          className={bem('head-cell', {
            roles: true,
            asc: state.sortAsc,
            sorted: state.sort === 'roles'
          })}
          onClick={clickSort('roles')}
        >
          {Lang.msg.proj.colRole}
        </div>
      </div>
    </>
  )
})
